import Toasted from 'vue-toasted'
import Vue from 'vue'

const toastOptions = {
  theme: 'primary', // ['primary', 'outline', 'bubble']
  position: 'bottom-center', // ['top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left']
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 2500
}

Vue.use(Toasted, toastOptions)

export default {
  methods: {
    showToast (msg, options) {
      this.$toasted.show(msg, options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-mixins/VuesticToasted.js